import type React from "react";
import { AlertCircle } from "lucide-react";

// Id of the message under a control. The control points at it with aria-describedby so a screen
// reader reads the message with the field.
export const fieldErrorId = (controlId: string): string => controlId + "-error";

// Props to spread on a control that may be invalid: aria-invalid plus aria-describedby pointing at
// its FieldError. Nothing is added while the field is valid.
export const invalidProps = (controlId: string, error?: string) =>
    error
        ? { "aria-invalid": true as const, "aria-describedby": fieldErrorId(controlId) }
        : {};

// Message shown directly under an invalid control, in the AA error colour with an icon so it is
// not signalled by colour alone.
const FieldError: React.FC<{ controlId: string; message?: string }> = ({ controlId, message }) =>
{
    if (!message)
    {
        return null;
    }

    return (
        <p id={fieldErrorId(controlId)} className="mt-1 flex items-center gap-1 text-sm font-medium text-(--ecpi-error-text-hex)">
            <AlertCircle className="h-4 w-4 shrink-0" aria-hidden="true" />
            <span>{message}</span>
        </p>
    );
};

export default FieldError;
